<template>
  <form-modal
    :ref="modalName"
    :name="modalName"
    class="NewAxis"
    title="New Axis"
    submit-name="Create"
    @submit="submit"
    @[Events.AFTER_CLOSE]="modalClosed"
  >
    <template v-if="currentLandscape">
      <lm-input
        ref="inputName"
        class="mt-8"
        label="Name"
        focus
        @submit="submitFromInput"
      />
    </template>
  </form-modal>
</template>

<script>
import {mapGetters} from 'vuex'
import {Events, Modal} from '@/lib/definitions'
import EventHub from '@/lib/eventHub'
import FormModal from '@/components/modals/FormModal'
import LmInput from '@/components/form/LmInput.vue'
import FormHelper from '@/components/form/formHelper'

export default {
  name: 'ModalNewAxis',
  components: {
    FormModal,
    LmInput
  },
  data() {
    return {
      Events,
      modalName: Modal.NEW_AXIS,
      modalRef: null,
      inputs: null,
      newAxisName: null
    }
  },
  computed: {
    ...mapGetters(['selectedActor', 'currentLandscape', 'userId'])
  },
  mounted() {
    this.modalRef = this.$refs[this.modalName]
    this.inputs = [this.$refs.inputName]
  },
  methods: {
    submitFromInput() {
      this.modalRef.submit()
    },
    submit() {
      if (FormHelper.validate(this.inputs)) {
        let payload = {name: this.$refs.inputName.data}
        this.$store
          .dispatch('createAxis', payload)
          .then(() => {
            this.newAxisName = this.$refs.inputName.data
            this.modalRef.submitSuccess()
          })
          .catch(error => this.modalRef.submitFails(error))
      } else {
        this.modalRef.submitFails()
      }
    },
    modalClosed({fromSubmit}) {
      if (fromSubmit) {
        const message = `Axis "${this.newAxisName}" has been created`
        EventHub.emit(Events.SHOW_SNACKBAR, message)
      }
    }
  }
}
</script>
